import fetch from "auth/FetchInterceptor";

const notificacaoService = {};

notificacaoService.visualizarTodas = async function () {
	return fetch({
		url: "/v1/rpc/notificacoes/visualizar-todas",
		method: "put",
	});
};

notificacaoService.buscarTodas = async function (
	page = 1,
	pageSize = 20,
	resolvida,
	busca,
	dataInicio,
	dataFim,
	categorias,
) {
	let url = `/v1/rpc/notificacoes/todas?page=${page}&limit=${pageSize}`;
	if (resolvida !== undefined) {
		url += `&resolvida=${resolvida}`;
	}
	if (busca) {
		url += `&busca=${encodeURIComponent(busca)}`;
	}
	if (dataInicio) {
		url += `&data_inicio=${encodeURIComponent(dataInicio)}`;
	}
	if (dataFim) {
		url += `&data_fim=${encodeURIComponent(dataFim)}`;
	}
	if (categorias && categorias.length > 0) {
		url += `&categoria=${encodeURIComponent(categorias.join(","))}`;
	}
	return fetch({
		url,
		method: "get",
		headers: {
			is_paginated: true,
		},
	});
};

notificacaoService.marcarComoVisualizada = async function (id) {
	return fetch({
		url: `/v1/rpc/notificacoes/${id}/visualizar`,
		method: "put",
	});
};

notificacaoService.resolver = async function (id) {
	return fetch({
		url: `/v1/rpc/notificacoes/${id}/resolver`,
		method: "put",
	});
};

notificacaoService.resolverTodas = async function () {
	return fetch({
		url: "/v1/rpc/notificacoes/resolver-todas",
		method: "put",
	});
};

notificacaoService.marcarComoPendente = async function (id) {
	return fetch({
		url: `/v1/rpc/notificacoes/${id}/pendente`,
		method: "put",
	});
};

notificacaoService.resolverPorReferencia = async function (
	subtipo,
	referenciaId,
) {
	return fetch({
		url: "/v1/rpc/notificacoes/resolver-por-referencia",
		method: "put",
		data: { subtipo, referencia_id: referenciaId },
	});
};

export default notificacaoService;
